import React from "react";
import { motion } from "framer-motion";
import SkillCard from "../components/SkillCard";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const childVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const Skills = () => {
  const skillItems = [
    { imgSrc: "/images/aws.svg", label: "AWS" },
    { imgSrc: "/images/python.svg", label: "Python" },
    { imgSrc: "/images/linux.svg", label: "Linux" },
    { imgSrc: "/images/docker.svg", label: "Docker" },
    { imgSrc: "/images/terraform.png", label: "Terraform" },
    { imgSrc: "/images/kubernetes.webp", label: "Kubernetes" },

    { imgSrc: "/images/icon.png", label: "SailPoint" },
    { imgSrc: "/images/okta.png", label: "Okta" },
    { imgSrc: "/images/powershell.png", label: "PowerShell" },
    { imgSrc: "/images/bash.png", label: "Bash" },

    { imgSrc: "/images/fastAPI.png", label: "FastAPI" },
    { imgSrc: "/images/nodejs.svg", label: "NodeJS" },
    { imgSrc: "/images/expressjs.svg", label: "ExpressJS" },
    { imgSrc: "/images/react.svg", label: "React" },
    { imgSrc: "/images/javascript.svg", label: "JavaScript" },

    { imgSrc: "/images/mongodb.svg", label: "MongoDB" },
    { imgSrc: "/images/github-mark-white.svg", label: "GitHub" },

    { imgSrc: "/images/java.svg", label: "Java" },
    { imgSrc: "/images/cpp.svg", label: "C++" },
    { imgSrc: "/images/c.svg", label: "C" },

    { imgSrc: "/images/gcp.png", label: "GCP" },
  ];

  return (
    <section className="section">
      <div className="container">
        <h2 className="headline-2 mb-8">Skill Set</h2>
        <motion.div
          className="grid gap-3 grid-cols-[repeat(auto-fill,_minmax(250px,_1fr))]"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {skillItems.map(({ imgSrc, label }, key) => (
            <motion.div key={key} variants={childVariants}>
              <SkillCard imgSrc={imgSrc} label={label} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;